module.exports = __webpack_public_path__ + "static/media/profile.a5847f4f.png";